<template>
    <MenuList :menuList="menuList" @handleClicks="clickMenu(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" :showTippy="false" />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import appConfig from "@/public/globalConfig";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class DownloadMenus extends Vue {
        @Prop({ default: false }) showAllDrop;

        activeIndex: number = -1;
        isBuild = appConfig.isBuild;
        get menuList() {
            let list = [
                { active: false, label: "file", kKey: "file", expand: true },
                { active: false, label: "edit", kKey: "edit", expand: true },
                { active: false, label: "select", kKey: "select", expand: true },
                { active: false, label: "insert", kKey: "insert", expand: true },
                { active: false, label: "arrange", kKey: "arrange", expand: true },
                { active: false, label: "view", kKey: "view", expand: true },
                { active: false, label: "help", kKey: "help", expand: true, isRender: this.isBuild }, //<!-- 开发环境保留帮助下拉菜单 -->
                { active: false, label: "symbol", kKey: "symbol", expand: true },
                { active: false, label: "searchFunc", kKey: "searchFunc" },
                {
                    active: false,
                    label: "ai",
                    kKey: "ai",
                    expand: true,
                    textIcon: require(
                        window.EDCONFIG.IS_SDK ? "@/app/assets/img/ai4/ai-chat-icon-sdk.svg" : "@/home/assets/img/newPage/recommend/ai-icon.svg"
                    ),
                }, //<!--  AI助手  -->
            ];

            if (!window.EDCONFIG.AI.ENABLE) {
                list.pop();
            }
            if (!window.EDCONFIG.SEARCH_FUNCTION_ENABLE) {
                list = list.filter((v) => v.label !== "searchFunc");
            }

            if (this.activeIndex !== -1) {
                list[this.activeIndex].active = true;
            }

            return {
                // container: "",
                list: list.map((item, i) => {
                    return {
                        ...item,
                        label: this.$t(item.label),
                    };
                }),
            };
        }
        @Watch("showAllDrop")
        watchShowAllDrop(val) {
            if (!val) {
                this.activeIndex = -1;
            }
        }

        clickMenu(...args) {
            let curIndex = args[0];
            let isSearch = this.menuList.list[curIndex];
            if (isSearch?.kKey === "searchFunc") {
                this.$emit("closeDrop");
                let ts: any = this;
                ts.$bus.$emit("toSearch");
            }
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeIndex = key;
            this.showExp(event, key);
        }
        showExp(e: MouseEvent, type: number) {
            let ts: any = this;
            let notSearch = this.menuList.list[type]?.kKey !== "searchFunc";
            let isAi = this.menuList.list[type]?.kKey === "ai";
            if (isAi) {
                ts.$bus.$emit("showThisDrop", e, 8);
                return;
            }
            if (notSearch) {
                ts.$bus.$emit("showThisDrop", e, type);
            }
        }
        mounted() {}
    }
</script>
<i18n>
{
  "zh": {
      "file": "文件",
      "edit": "编辑",
      "select": "选择",
      "insert": "插入",
      "arrange": "布局",
      "view": "视图",
      "symbol": "符号",
      "help": "帮助",
      "searchFunc": "功能查找",
      "ai": "AI"
  },
   "en": {
      "file": "File",
      "edit": "Edit",
      "select": "Select",
      "insert": "Insert",
      "arrange": "Layout",
      "view": "View",
      "help": "Help",
      "symbol": "Symbol",
      "searchFunc": "Search Feature",
      "ai": "AI"
  },
   "fr": {
      "file": "Fichier",
      "edit": "Modifier",
      "select": "Sélectionner",
      "insert": "Insérer",
      "arrange": "Disposition",
      "view": "Vue",
      "help": "Aide",
      "symbol": "Forme",
      "searchFunc": "Recherche de Fonction",
      "ai": "AI"
  },
  "es": {
      "file": "Archivo",
      "edit": "Editar",
      "select": "Seleccionar",
      "insert": "Insertar",
      "arrange": "Diseño",
      "view": "Ver",
      "help": "Ayuda",
      "symbol": "Símbolo",
      "searchFunc": "Buscar Caracteristica ",
      "ai": "AI"
  },
  "jp": {
      "file": "ファイル",
      "edit": "編集",
      "select": "選択",
      "insert": "挿入",
      "arrange": "レイアウト",
      "view": "表示",
      "help": "ヘルプ",
      "symbol": "図形",
      "searchFunc": "機能検索",
      "ai": "AI"
  },
 
  "pt": {
      "file": "Ficheiro",
      "edit": "Editar",
      "select": "Selecionar",
      "insert": "Inserir",
      "arrange": "Layout",
      "view": "Visualização",
      "help": "Ajuda",
      "symbol": "Símbolo",
      "searchFunc": "Encontrar Característica",
      "ai": "AI"
  },
  "de": {
      "file": "Datei",
      "edit": "Bearbeiten",
      "select": "Auswählen",
      "insert": "Einfügen",
      "arrange": "Layout",
      "view": "Ansicht",
      "help": "Hilfe",
      "symbol": "Form bearbeiten",
      "searchFunc": "Suchen",
      "ai": "AI"
  },
  "it": {
      "file": "File",
      "edit": "Modifica",
      "select": "Selezionare",
      "insert": "Inserisci",
      "arrange": "Layout",
      "view": "Vista",
      "help": "Aiuto",
      "symbol": "Simboli",
      "searchFunc": "Trova Funzioni",
      "ai": "AI"
  },
 
  "tw": {
      "file": "檔案",
      "edit": "編輯",
      "select": "選擇",
      "insert": "插入",
      "arrange": "佈局",
      "view": "視圖",
      "help": "幫助",
      "symbol": "形狀",
      "searchFunc": "功能查找",
      "ai": "AI"
  }
}
</i18n>
